module.exports = __webpack_public_path__ + "img/lr.2b40c813.svg";